module.exports = __webpack_public_path__ + "fonts/Canela-Thin.98cd007.woff2";